<template>
  <div class="cropper-wrapper" :key="imgUrl || 1">
    <div class="cropper-overlay" @click="close"></div>
    <div class="cropper-modal">
      <div class="cropper-modal__title acr-bold-18">Highlight a face in a uploaded photo</div>
      <div class="cropper-modal__subtitle">To more accurately determine the person's face, ythe face will cover more than 80% of the selected area</div>
      <div class="cropper-modal__btn" @click="close">
        <svgicon name="Close"></svgicon>
      </div>
      <div class="cropper">
        <img :src="imgUrl" id="croppr" alt="">
      </div>
      <div class="persons-modal__footer">
        <div class="persons-modal__btn">Cancel</div>
        <div class="persons-modal__btn grey green" @click.prevent="capture">Done</div>
      </div>
    </div>
  </div>
</template>

<script>
import Croppr from 'croppr';
export default {
  name: "BaseCropper",
  data() {
    return {
      cropperInstance: null,
      options: {
        // maxSize: [155, 166, 'px'],
        minSize: [50, 50, 'px'],
        startSize: [50, 50, 'px']
      },
    }
  },
  props: ['imgUrl'],
  watch: {
    imgUrl() {
      this.$nextTick(() => {
        this.init();
      })
    }
  },
  methods: {
    init() {
      if (!this.imgUrl) return;

      this.cropperInstance = new Croppr('#croppr', {
        ...this.options
      });
      this.cropperInstance.moveTo(200, 100)
    },
    capture() {
      const cropRect = this.cropperInstance.getValue();
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.width = cropRect.width;
      canvas.height = cropRect.height;
      context.drawImage(
        this.cropperInstance.imageEl,
        cropRect.x,
        cropRect.y,
        cropRect.width,
        cropRect.height,
        0,
        0,
        canvas.width,
        canvas.height,
      );
      const image = canvas.toDataURL("image/png");

      context.clearRect(0, 0, canvas.width, canvas.height);
      this.$emit('captured', image);
      this.close();
    },
    close() {
      this.cropperInstance.destroy();
      this.$emit('close');
    },
  },
}
</script>

<style lang="scss">
  .cropper {
    position: relative;
    &-wrapper {
      position: fixed;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      z-index: 10000;
    }
    &-overlay {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.5);
      z-index: 2000;
    }
    &-modal {
      width: 582px;
      max-height: 99vh;
      padding: 40px;
      padding-bottom: 110px;
      border-radius: 6px;
      z-index: 2001;
      background-color: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      img {
        max-height: 380px;
      }
      &__title {
        font-style: normal;
        font-weight: bold;
        font-size: 22px;
        line-height: 30px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }
      &__subtitle {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 22px;
        max-width: 415px;
      }
      &__btn {
        position: absolute;
        right: 40px;
        top: 35px;
        z-index: 2;
        width: 40px;
        height: 40px;
        /*background: #F2F4F6;*/
        border-radius: 6px;
        cursor: pointer;
        color: rgba(36, 49, 67, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .3s ease-in-out;
        &.active {
          color: white;
          background: #9BC225;
        }
        svg {
          width: 17px;
          height: 16px;
        }
      }
    }
  }

  .croppr-container * {
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  .croppr-container {
    text-align: center;
    border-radius: 6px;
    background-color: rgba(36,49,67, .1);
  }

  .croppr-container img {
    vertical-align: middle;
    max-width: 100%;
    border-radius: 6px;
  }

  .croppr {
    position: relative;
    display: inline-block;
  }

  .croppr-overlay {
    border-radius: 6px;
    background: rgba(0,0,0,0.5);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    cursor: crosshair;
  }

  .croppr-region {
    border: 4px solid #fff;
    position: absolute;
    z-index: 3;
    cursor: move;
    top: 0;
  }

  .croppr-imageClipped {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
    pointer-events: none;
  }

  .croppr-handle {
    border: 1px solid black;
    opacity: 0;
    background-color: white;
    width: 10px;
    height: 10px;
    position: absolute;
    z-index: 4;
    top: 0;
  }
</style>
